import type { SimplePaletteColorOptions } from '@mui/material'

const Color: SimplePaletteColorOptions = {
  main: '#FF9A7A',
  light: '#ffcca9',
  dark: '#c86b4d',
  contrastText: 'rgba(0, 0, 0, 0.87)',
}

export default Color
